module.exports = __webpack_public_path__ + "fonts/Gilroy-ExtraBoldItalic.e43cca6c.woff";